// src/layouts/MainLayout.js
import React from "react";
import { useLocation } from "react-router-dom";
import "./MainLayout.css";
import Header from "../../Header/Header/Header";
import SubFooter from "../../Footer/SubFooter/SubFooter";
import CallForPapersSidebar from "../../CommonWidgets/CallForPapersSidebar/CallForPapersSidebar";
import InfoCardsSection from "../../CommonWidgets/InfoCardsSection/InfoCardsSection";

export default function MainLayout({ children }) {
  const location = useLocation();

  // ✅ Add all routes where you want InfoCardsSection to appear
  const showInfoCardsOn = [
    "/AimAndScope",
    "/AuthorsGuideline",
    "/Topics",
    "/Fees",
  ];

  const shouldShowInfoCards = showInfoCardsOn.includes(location.pathname);

  return (
    <div className="ijacna-layout">
      <Header />
      <main className="ijacna-main-content">
        {children}
        <CallForPapersSidebar />
      </main>

      {/* ✅ Conditionally show InfoCardsSection */}
      {shouldShowInfoCards && (
        <div className="ijacna-info-cards-section-wrapper">
          <InfoCardsSection />
        </div>
      )}

      <SubFooter />
    </div>
  );
}
